








import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class extends Vue {
    @Prop({ default: '暂无数据' }) text!: string
    @Prop({ default: '120px' }) imgWidth!: string
    @Prop() btnText!: string
}
